import React from 'react'
import {graphql} from 'gatsby'
import LegalPageTemplate from '../../components/templates/legal/LegalPageTemplate'

const TermsPrivateAIPage = ({data}) => {
    return <LegalPageTemplate data={data} />
}

export const query = graphql`
  query TermsPrivateAIPageQuery($language: String = "en") {
    markdownRemark(
      frontmatter: {
        type: {eq: "terms-privateai"}
        language: {eq: $language}
      }
    ) {
      html
      frontmatter {
        title
        language
        type
        lastUpdated
      }
    }
  }
`

export default TermsPrivateAIPage

